import { connect } from 'react-redux';
import { onChangeInformation } from './../../../../../actions/addOrder';
import ShipmentRemarkComponent from './../../../components/shipment-remark';
import './styles.css';

class ShipmentRemark extends ShipmentRemarkComponent {
    constructor(props) {
        super(props)
    }
}

const mapStateToProps = state => {
    return {
        order: state.addOrder,
        classes: state.addOrder.classes,
        information: state.addOrder.information,
        shipperInformation: state.addOrder.shipperInformation,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeInformation: payload => {
            dispatch(onChangeInformation(payload))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentRemark)




// WEBPACK FOOTER //
// ./src/containers/orders/add/components/shipment-remark/index.js